import { a as __rest } from '../../tslib.es6.esm.js';
import { jsx } from 'react/jsx-runtime';
import * as RadioGroup$1 from '@radix-ui/react-radio-group';
import styles from './RadioGroup.styles.esm.js';

const RadioGroup = (_a) => {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    const classes = styles({
        class: className,
    });
    return (jsx(RadioGroup$1.Root, Object.assign({ className: classes }, props, { children: children })));
};
const RadioItem = RadioGroup$1.Item;
const RadioIndicator = RadioGroup$1.Indicator;
RadioGroup.displayName = "RadioGroup";

export { RadioGroup, RadioIndicator, RadioItem };
